window._ = require('lodash')
window.Popper = require('popper.js').default

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
	window.$ = window.jQuery = require('jquery')

	require('bootstrap')
	require('bootstrap-select')
	require('bootstrap-input-spinner')
} catch (e) { }

$(document)
	.ajaxStart(function () {
		$('#loading-loader').addClass('is-active')
	})
	.ajaxComplete(function () {
		$('#loading-loader').removeClass('is-active')
	})

window.Noty = require('noty')
window.NProgress = require('nprogress')
window.Mustache = require('mustache')
window.moment = require('moment-timezone')
window.numeral = require('numeral')
window.dragula = require('dragula')
window.Dropzone = require('dropzone').default
window.mapboxgl = require('mapbox-gl')
window.Chart = require('chart.js')
window.ClipboardJS = require('clipboard')

window.Noty.overrideDefaults({
	layout: 'topRight',
	theme: 'metroui',
	progressBar: true,
	timeout: 4000,
	closeWith: ['click', 'button'],
	animation: {
		open: 'animated bounceInRight',
		close: 'animated bounceOutRight'
	}
})

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios').default

axios.interceptors.request.use((config) => {
	$('#loading-loader').addClass('is-active')
	return config
}, (error) => {
	$('#loading-loader').removeClass('is-active')
	return Promise.reject(error)
})

axios.interceptors.response.use((response) => {
	$('#loading-loader').removeClass('is-active')
	return response
}, (error) => {
	$('#loading-loader').removeClass('is-active')
	return Promise.reject(error)
})

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
	window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
	console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

import Echo from 'laravel-echo'
window.Pusher = require('pusher-js')
window.Echo = new Echo({
	broadcaster: 'reverb',
	key: window.Laravel.reverb.key,
	wsHost: window.Laravel.reverb.host,
	wsPort: window.Laravel.reverb.port ?? 80,
	wssPort: window.Laravel.reverb.port ?? 443,
	forceTLS: (window.Laravel.reverb.scheme ?? 'https') === 'https',
	enabledTransports: ['ws', 'wss'],
})
